







import { computed, defineComponent } from "@vue/composition-api";
import { getMediaDuration } from "@scrile/tools/dist/lib/TimeHelpers";

export default defineComponent({
  name: "AudioRecordingDuration",
  props: {
    show: { type: Boolean, default: false },
    durationMs: { type: Number, default: 0 },
  },
  setup(props) {
    const durationText = computed(() => getMediaDuration(props.durationMs));

    return { durationText };
  },
});
